import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';

export const CREATE_BUSINESS_CARD_RECEIVE = 'CREATE_BUSINESS_CARD_RECEIVE';
export const CREATE_BUSINESS_CARD_PREVIEW = 'BUSINESS_CARD_PREVIEW';
export const CREATE_BUSINESS_CARD_CREATE = 'BUSINESS_CARD_CREATE';
export const CREATE_BUSINESS_CARD_LOAD_ERROR = 'CREATE_BUSINESS_CARD_LOAD_ERROR';
export const CREATE_BUSINESS_CARD_SHOW_INFO = 'CREATE_BUSINESS_CARD_SHOW_INFO';
export const CREATE_BUSINESS_CARD_HIDE = 'CREATE_BUSINESS_CARD_HIDE';

const rootRoute = '/api/createBusinessCard';
const contentType_Pdf = 'application/pdf';
const contentType_Image = 'image/jpeg'; 




export const renderPdfinIframe = (base64Str) => (dispatch, getState) => {

    var ieEDGE = navigator.userAgent.match(/Edge/g);
    var ie = navigator.userAgent.match(/.NET/g); // IE 11+
    var oldIE = navigator.userAgent.match(/MSIE/g);

    //Create a Blob from the PDF Stream
    const blob = b64toBlob(base64Str, contentType_Pdf);

    const fileURL = URL.createObjectURL(blob);

    let ifrm = document.getElementById("pdfPreview"); //document.createElement("iframe");
    ifrm.src = fileURL;
    ///ifrm.setAttribute("src", fileURL);
}



const callPrint = (iframeId) => (dispatch, getState) => {
    var PDF = document.getElementById(iframeId);
    PDF.focus();
    PDF.contentWindow.print();
}


export const downloadPdf = (base64Str) => (dispatch, getState) => {
    const linkSource = `data:${contentType_Pdf};base64,${base64Str}`;
    const downloadLink = document.createElement("a");
    const fileName = "file.pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);

    downloadLink.click();
    downloadLink.remove();
}

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().createBusinessCard.showInfo));
}

const show = visible => ({
    type: CREATE_BUSINESS_CARD_SHOW_INFO,
    payload: {
        showInfo: visible,
    }
})

export const businessCardError = error => ({
    type: CREATE_BUSINESS_CARD_LOAD_ERROR,
    payload: {
        error,
    }
})

export const adjustBusinessCard = (variantId) => {  
   // alert(variantId)
    return post(rootRoute + '/adjustpdf', variantId)
        //.then(response => response.json())
        .then(function (reply) {
            //alert(reply);
        });
}

export const addDynamicProductToCart = ({inputValues, variantId}) => (dispatch, getState) => {
    const BCForm = document.getElementById("dynamicCardForm");
    if (BCForm) {
        var formdata = new FormData(BCForm);
        return post(rootRoute + '/adddynamicproducttocart', { inputValues, variantId})
            .then(response => response.json())
            .then(response => dispatch(handleResponse(response)))
            //.then(cart => {
            //    dispatch(receive(cart));
            //    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
            //})
            .catch(ex => dispatch(catchError(ex, error => businessCardError(error))));
    } else {
    }
}

export const generateBusinessCard = () => (dispatch, getState) => {

    const ifrm = document.getElementById("pdfPreview"); //document.createElement("iframe");
    ifrm.style.backgroundColor = "transparent";
    ifrm.frameBorder = "0";
    ifrm.allowTransparency = "true";
    const fileName = "businessCard";

    const BCForm = document.getElementById("dynamicCardForm");
    if (BCForm) {
        var formdata = new FormData(BCForm);

        return post(rootRoute + '/adddynamicproducttocart', formdata)
            .then(response => response.json())
            .then(response => dispatch(handleResponse(response)))
            //.then(cart => {
            //    dispatch(receive(cart));
            //    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
            //})
            .catch(ex => dispatch(catchError(ex, error => businessCardError(error))))
            ;
    }
    //BCForm.target = "pdfPreview";
    //BCForm.method = "post";
    //BCForm.action = rootRoute + "/previewpdf";
    //var formdata = new FormData(BCForm);

    //BCForm.submit();

    //// displayType = inline     (inline in browser)
    ////               attachment (download as attachment)
    //ifrm.src = rootRoute + '/downloadPdf?displayType=inline&fData=null';

    //location.href = rootRoute + '/downloadPdf?displayType=attachment';
    // let fData = "test namn";

    //const fileName = "businessCard";
    //return post(rootRoute + '/SaveBusinessCardToDisk', fileName, fData)
    //    .then(response => response.json())
    //    .then(response => dispatch(handleResponse(response)))
    //    //.then(cart => {
    //    //    dispatch(receive(cart));
    //    //    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
    //    //})
    //    .catch(ex => dispatch(catchError(ex, error => businessCardError(error))))
    //    ;


    //const fileName = "businessCard";
    //return post(rootRoute + '/SaveBusinessCardToDisk', fileName, fData)
    //    .then(response => response.json())
    //    .then(response => dispatch(handleResponse(response)))
    //    //.then(cart => {
    //    //    dispatch(receive(cart));
    //    //    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
    //    //})
    //    .catch(ex => dispatch(catchError(ex, error => businessCardError(error))))
    //    ;
}
